// angualar

// ag-grid
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';

import { AiDialogModule } from './_components/ai/ai-dialog/ai-dialog.module';
import { SpeedDialModule } from 'primeng/speeddial';
import { CurrencyPipe } from '@angular/common';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { NgModule, ErrorHandler, Injectable, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule as MatFormFieldModule, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { ListboxModule } from 'primeng/listbox';

// application
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { JwtInterceptor, ErrorInterceptor, UidInterceptor, MaterialModule, fakeBackendProvider } from './_helpers';
import { PrimeNgDialogAppendDirective } from './_helpers/primeng-dialog-append.directive';
import { TinyMceDialogAppendDirective } from './_helpers/tiny-mce-dialog-append.directive';
import { ReservationResolver, UserResolver, UserRoleListResolver, TaskResolver, AvailablePropertyFeaturesResolver, AvailableDevelopmentFeaturesResolver, PropertyResolver, PropertyListResolver } from './_resolvers';
import { AlertComponent, ErrorDialogComponent } from './_components';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { UserComponent } from './_components/user/user/user.component';
import { UserListComponent } from './_components/user/user-list/user-list.component';
import { UserRoleComponent } from './_components/user/user-role/user-role.component';
import { UserRoleListComponent } from './_components/user/user-role-list/user-role-list.component';
import { SpinnerComponent } from '@app/_helpers/spinner/spinner.component';

import { UserContactComponent } from './_components/user/user-contact/user-contact.component';

import { PasswordResetComponent } from './_components/user/password-reset/password-reset.component';
import { PasswordResetRequestComponent } from './_components/user/password-reset-request/password-reset-request.component';
import { RateProfileComponent } from './_components/rate/rate-profile/rate-profile/rate-profile.component';
import { RateProfileListComponent } from './_components/rate/rate-profile/rate-profile-list/rate-profile-list.component';
import { RateManagerComponent } from './_components/rate/rate-manager/rate-manager/rate-manager.component';
import { RateManagerListComponent } from './_components/rate/rate-manager/rate-manager-list/rate-manager-list.component';
import { ChannelComponent } from './_components/channel/channel/channel.component';
import { ChannelListComponent } from './_components/channel/channel-list/channel-list.component';


import { TaskComponent } from './_components/task/task/task.component';
import { TaskListComponent } from './_components/task/task-list/task-list.component';
import { TemplateListComponent } from './_components/template/template-list/template-list.component';
import { TemplateComponent } from './_components/template/template/template.component';
import { ProjectComponent } from './_components/task/impl/project/project.component';
import { MaintenanceComponent } from './_components/task/impl/maintenance/maintenance/maintenance.component';
import { MaintenanceListComponent } from './_components/task/impl/maintenance/maintenance-list/maintenance-list.component';
import { PhoneComponent } from './_components/task/impl/phone/phone.component';
import { IntervalComponent } from './_components/task/interval/interval/interval.component';
import { ExtraInfoSelectComponent } from './_components/_helpers/extra-info-select-array.component';

import { NoteComponent } from './_components/task/note/note/note.component';

import { MessageComponent } from './_components/message/message/message.component';
import { MessageListComponent } from './_components/message/message-list/message-list.component';
import { MessageTemplateComponent } from './_components/message/message-template/message-template/message-template.component';
import { MessageTemplateListComponent } from './_components/message/message-template/message-template-list/message-template-list.component';
import { AuditListComponent } from './_components/audit-list/audit-list.component';
import { AuditEnrichedListComponent } from './_components/audit-enriched-list/audit-enriched-list.component';

import { PropertyComponent } from './_components/property/property/property.component';
import { PropertyListComponent } from './_components/property/property-list/property-list.component';
import { PropertyDeleteComponent } from './_components/property/property-delete/property-delete.component';

import { DevelopmentComponent } from './_components/development/development/development.component';
import { DevelopmentListComponent } from './_components/development/development-list/development-list.component';

import { FeatureComponent } from '@app/_components/property/feature/feature/feature.component';
import { FeatureListComponent } from '@app/_components/property/feature/feature-list/feature-list.component';
import { FeatureListAllComponent } from '@app/_components/property/feature/feature-list-all/feature-list.component';

import { TagAddModalComponent } from './_components/task/tag/tag-add-modal/tag-add-modal.component';
import { PropertyMlsComponent } from './_components/property/property-mls/property-mls.component';



// helpers
import { PropertySelectComponent } from './_components/_helpers/property-select.component';
import { TeamSelectComponent } from './_components/_helpers/team-select.component';
import { UserSelectComponent } from './_components/_helpers/user-select.component';
import { TagSelectComponent } from './_components/_helpers/tag-select.component';
import { TagJoinComponent } from './_components/_helpers/tag-join/tag-join.component';
import { TagSelectModalComponent } from './_components/_helpers/tag-join/tag-select-modal/tag-select-modal.component';
import { TagJoinListComponent } from './_components/_helpers/tag-join-list/tag-join-list.component';
import { TagJoinFilterComponent } from './_components/_helpers/tag-join-filter/tag-join-filter.component';
import { TagSelectDdComponent } from './_components/task/tag/tag-select-dd/tag-select-dd.component';


// shared
import { ShortTermRentalSelectComponent } from './_components/_shared/short-term-rental-select/short-term-rental-select.component';
import { TopicMessagesViewComponent } from './_components/_shared/topic-messages-view/topic-messages-view.component';

// primeng
import { TreeModule } from 'primeng/tree';
import { TreeNode } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { DividerModule } from 'primeng/divider';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { BlockUIModule } from 'primeng/blockui';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChartModule } from 'primeng/chart';
import { TreeTableModule } from 'primeng/treetable';
import { KnobModule } from 'primeng/knob';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CarouselModule } from 'primeng/carousel';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenubarModule } from 'primeng/menubar';
import { OrderListModule } from 'primeng/orderlist';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SpinnerModule } from 'primeng/spinner';
import { StepsModule } from 'primeng/steps';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TagModule } from 'primeng/tag';

// components
import { TaskSummaryComponent } from './_components/task/task-summary/task-summary.component';
import { TaskEventComponent } from './_components/task/task-event/task-event.component';
import { AccountingRefundComponent } from './_components/task/impl/accounting-refund/accounting-refund.component';
import { BedroomComponent } from './_components/property/bedroom/bedroom.component';
import { BedroomFormComponent } from './_components/property/bedroom/components/bedroom-form/bedroom-form.component';
import { BedComponent } from './_components/property/bed/bed.component';
import { BedFormComponent } from './_components/property/bed/components/bed-form/bed-form.component';
import { BathroomFormComponent } from './_components/property/bathroom/components/bathroom-form/bathroom-form.component';
import { BathroomComponent } from './_components/property/bathroom/bathroom.component';
import { RateBucketComponent } from './_components/rate/rate-bucket/rate-bucket.component';
import { RateBucketFormComponent } from './_components/rate/rate-bucket/rate-bucket-form/rate-bucket-form.component';
import { RateBucketDetailComponent } from './_components/rate/rate-bucket-detail/rate-bucket-detail.component';
import { RateBucketDetailFormComponent } from './_components/rate/rate-bucket-detail/rate-bucket-detail-form/rate-bucket-detail-form.component';
import { RateBulkEditComponent } from './_components/rate/rate-bulk-edit/rate-bulk-edit.component';
import { OccupancySummaryComponent } from './_components/rate/occupancy-summary/occupancy-summary.component';

import { RateLosComponent } from './_components/rate/rate-los/rate-los.component';
import { GuestProfileComponent } from './_components/guest-profile/guest-profile/guest-profile.component';
import { GuestProfileListComponent } from './_components/guest-profile/guest-profile-list/guest-profile-list.component';
import { ReservationComponent } from './_components/reservation/components/reservation/reservation.component';
import { ReservationListComponent } from './_components/reservation/components/reservation-list/reservation-list.component';
import { RateSummaryComponent } from './_components/rate/rate-summary/rate-summary.component';
import { RentalsUnitedComponent } from './_components/rentals-united/rentals-united.component';
import { RuBuildingComponent } from './_components/rentals-united/components/ru-building/ru-building.component';
import { RuPropertyComponent } from './_components/rentals-united/components/ru-property/ru-property.component';
import { RuAvailabilityComponent } from './_components/rentals-united/components/ru-availability/ru-availability.component';
import { RuPricesComponent } from './_components/rentals-united/components/ru-prices/ru-prices.component';
import { RuReservationComponent } from './_components/rentals-united/components/ru-reservation/ru-reservation.component';
import { RuQualityCheckComponent } from './_components/rentals-united/components/ru-quality-check/ru-quality-check.component';
import { VRBOLogmanComponent } from './_components/vrbo_logman/vrbo-logman.component';
import { VRBOComponent } from './_components/vrbo/vrbo.component';
import { VRBOPropertyComponent } from './_components/vrbo/components/vrbo-property/vrbo-property.component';
import { VRBOReservationComponent } from './_components/vrbo/components/vrbo-reservation/vrbo-reservation.component';
import { VRBOAvailabilityComponent } from './_components/vrbo/components/vrbo-availability/vrbo-availability.component';
import { VRBOReservationsComponent } from './_components/vrbo/components/vrbo-reservations/vrbo-reservations.component';
import { VRBOLodgingRateComponent } from './_components/vrbo/components/vrbo-lodging-rate/vrbo-lodging-rate.component';
import { VRBOUnitAvailabilityComponent } from './_components/vrbo/components/vrbo-unit-availability/vrbo-unit-availability.component';
import { VRBOPromotionsComponent } from './_components/vrbo/components/vrbo-promotions/vrbo-promotions.component';
import { VRBOPromotionsDashboardComponent } from './_components/vrbo/components/vrbo-promotions-dashboard/vrbo-promotions-dashboard.component';
import { VRBOReviewsComponent } from './_components/vrbo/components/vrbo-reviews/vrbo-reviews.component';
import { VRBOReviewDetailComponent } from './_components/vrbo/components/vrbo-review-detail/vrbo-review-detail.component';
import { VRBOReviewRespondComponent } from './_components/vrbo/components/vrbo-review-respond/vrbo-review-respond.component';
import { VRBORateGuestComponent } from './_components/vrbo/components/vrbo-rate-guest/vrbo-rate-guest.component';
import { GoogleComponent } from './_components/google/google.component';
import { GoogleDataTableComponent } from './_components/google/components/google-data-table/google-data-table.component';
import { GoogleLogmanComponent } from './_components/google_logman/google-logman.component';
import { ReviewComponent } from './_components/review/components/review/review.component';
import { ReviewListComponent } from './_components/review/components/review-list/review-list.component';
import { ReservationSearchComponent } from './_components/reservation/components/reservation-search/reservation-search.component';
import { ReservationSearchFormComponent } from './_components/reservation/components/reservation-search/reservation-search-form/reservation-search-form.component';
import { FeatureDisplayComponent } from './_components/property/feature/feature-display/feature-display.component';
import { PropertyAdminComponent } from './_components/property/property-admin/property-admin.component';
import { LogmanComponent } from './_components/logman/components/logman/logman.component';
import { LogmanListComponent } from './_components/logman/components/logman-list/logman-list.component';
import { RuReservationDetailComponent } from './_components/rentals-united/components/ru-reservation/components/ru-reservation-detail/ru-reservation-detail.component';
import { RateOverrideComponent } from './_components/rate/rate-override/rate-override.component';
import { RateOverrideFormComponent } from './_components/rate/rate-override/components/rate-override-form/rate-override-form.component';

import { HousekeepingOrderComponent } from './_components/housekeeping-order/housekeeping-order.component';
import { TestComponent } from './_components/test/test/test.component';
import { TestListComponent } from './_components/test/test-list/test-list.component';
import { TestListCellEditComponent } from './_components/test/test-list-cell-edit/test-list-cell-edit.component';
import { GuestRefundComponent } from './_components/guest-refund/guest-refund/guest-refund.component';
import { GuestRefundListComponent } from './_components/guest-refund/guest-refund-list/guest-refund-list.component';
import { OwnerProfileComponent } from './_components/owner-profile/owner-profile/owner-profile.component';
import { OwnerProfileListComponent } from './_components/owner-profile/owner-profile-list/owner-profile-list.component';
import { PropertyProfileListComponent } from './_components/property-profile/property-profile-list/property-profile-list.component';
import { PropertyProfileComponent } from './_components/property-profile/property-profile/property-profile.component';
import { CancellationPolicyViewComponent } from './_components/cancellation-policy/cancellation-policy-view/cancellation-policy-view.component';
import { FileUploadListComponent } from './_components/file-upload/file-upload-list/file-upload-list.component';
import { FileUploadComponent } from './_components/file-upload/file-upload/file-upload.component';
import { OrderProductListComponent } from './_components/order-product/order-product-list/order-product-list.component';
import { OrderProductComponent } from './_components/order-product/order-product/order-product.component';
import { FeaturesComponent } from './_components/feature/feature/features.component';
import { GuestMoveListComponent } from './_components/guest-move/guest-move-list/guest-move-list.component';
import { GuestMoveComponent } from './_components/guest-move/guest-move/guest-move.component';
import { RateBucketCopyFormComponent } from './_components/rate/rate-bucket/rate-bucket-copy-form/rate-bucket-copy-form.component';
import { ResSelectComponent } from './_components/_shared/reservation-select/res-select.component';
import { ActivityComponent } from './_components/activity/activity/activity.component';
import { ActivityListComponent } from './_components/activity/activity-list/activity-list.component';
import { ActivityWishlistComponent } from './_components/activity-wishlist/activity-wishlist/activity-wishlist.component';
import { ActivityWishlistListComponent } from './_components/activity-wishlist/activity-wishlist-list/activity-wishlist-list.component';
import { ActivityFeeComponent } from './_components/activity-fee/activity-fee/activity-fee.component';
import { ActivityFeeListComponent } from './_components/activity-fee/activity-fee-list/activity-fee-list.component';
import { ActivityProviderComponent } from './_components/activity-provider/activity-provider/activity-provider.component';
import { ActivityProviderListComponent } from './_components/activity-provider/activity-provider-list/activity-provider-list.component';
import { ActivityScheduleComponent } from './_components/activity-schedule/activity-schedule/activity-schedule.component';
import { ActivityScheduleListComponent } from './_components/activity-schedule/activity-schedule-list/activity-schedule-list.component';
import { ActivitiesManagerComponent } from './_components/activities-manager/activities-manager.component';
import { ActivityFormComponent } from './_components/activity/activity-form/activity-form.component';
import { ActivityProviderFormComponent } from './_components/activity-provider/activity-provider-form/activity-provider-form.component';
import { ActivityReservationFormComponent } from './_components/activity-reservation/activity-reservation-form/activity-reservation-form.component';
import { ActivityReservationListComponent } from './_components/activity-reservation/activity-reservation-list/activity-reservation-list.component';
import { RoundNumPipe, TruncatePipe, SumPropPipe, MaxValPipe, PaidCountPipe, ActivityCountByCatPipe } from './_components/_shared/kbm-activities.pipe';
import { PersonListComponent } from './_components/person/person-list/person-list.component';
import { PersonComponent } from './_components/person/person/person.component';
import { PersonAddressComponent } from './_components/person-address/person-address/person-address.component';
import { PersonAddressListComponent } from './_components/person-address/person-address-list/person-address-list.component';
import { PersonEmailListComponent } from './_components/person-email/person-email-list/person-email-list.component';
import { PersonEmailComponent } from './_components/person-email/person-email/person-email.component';
import { PersonPhoneListComponent } from './_components/person-phone/person-phone-list/person-phone-list.component';
import { PersonPhoneComponent } from './_components/person-phone/person-phone/person-phone.component';
import { PersonSocialListComponent } from './_components/person-social/person-social-list/person-social-list.component';
import { PersonSocialComponent } from './_components/person-social/person-social/person-social.component';
import { PropertyImageVertLayoutComponent } from './_components/property/image/property-image-vert-layout/property-image-vert-layout.component';
import { ConstantService } from './_services/constant.service';
import { OrderDetailListComponent } from './_components/reservation/components/reservation/order-detail/order-detail-list/order-detail-list.component';
import { OrderDetailComponent } from './_components/reservation/components/reservation/order-detail/order-detail/order-detail.component';
import { WorkOrderComponent } from './_components/reservation/components/reservation/work-order/work-order.component';
import { PictureListComponent } from './_components/picture/picture-list/picture-list.component';
import { PictureComponent } from './_components/picture/picture/picture.component';
import { PropertyImageComponent } from './_components/property/image/property-image.component/property-image.component';
import { LostFoundComponent } from './_components/lost-found/lost-found/lost-found.component';
import { LostFoundListComponent } from './_components/lost-found/lost-found-list/lost-found-list.component';
import { RUDetailedLocationListComponent } from './_components/ru-detailed-location/ru-detailed-location-list/ru-detailed-location-list.component';
import { RUDetailedLocationComponent } from './_components/ru-detailed-location/ru-detailed-location/ru-detailed-location.component';

import { GuestRefundReasonComponent } from './_components/guest-refund-reason/guest-refund-reason/guest-refund-reason.component';
import { GuestRefundReasonListComponent } from './_components/guest-refund-reason/guest-refund-reason-list/guest-refund-reason-list.component';


// reports
import { SearchTemplateComponent } from './_components/report/search-template/search-template.component';
import { ResRevComponent } from './_components/report/components/res-rev/res-rev.component';
import { ResRevDetailComponent } from './_components/report/components/res-rev-detail/res-rev-detail.component';
import { ResRevTotalComponent } from './_components/report/components/res-rev-total/res-rev-total.component';
import { ResRevTotalDetailComponent } from './_components/report/components/res-rev-total-detail/res-rev-total-detail.component';
import { ResRevReportComponent } from './_components/report/reports/res-rev-report/res-rev-report.component';
import { CheckInOutReportComponent } from './_components/report/reports/check-in-out-report/check-in-out-report.component';
import { VacancyReportComponent } from './_components/report/reports/vacancy-report/vacancy-report.component';
import { OccupancySummaryReportComponent } from './_components/report/reports/occupancy-summary-report/occupancy-summary-report.component';
import { DailySummaryReportComponent } from './_components/report/reports/daily-summary-report/daily-summary-report.component';
import { ResSalesReportComponent } from './_components/report/reports/res-sales-report/res-sales-report.component';
import { EscrowsReportComponent } from './_components/report/reports/escrows-report/escrows-report.component';
import { EscrowReportComponent } from './_components/report/reports/escrow-report/escrow-report.component';
import { EscrowReportAuditComponent } from './_components/report/reports/escrow-report-audit/escrow-report-audit.component';
import { EscrowPaymentMappingComponent } from './_components/report/reports/escrow-payment-mapping/escrow-payment-mapping.component';
import { ReportsDashboardComponent } from './_components/report/reports/reports-dashboard/reports-dashboard.component';
import { ReservationSummaryReportComponent } from './_components/report/reports/reservation-summary-report/reservation-summary-report.component';
import { PaymentSummaryReportComponent } from './_components/report/reports/payment-summary-report/payment-summary-report.component';
import { ReservationSelectComponent } from './_components/reservation/components/reservation-select/reservation-select.component';

// tasks
import { TaskHomeComponent } from './_components/task/task-home/task-home.component';
import { TaskFolderNavComponent } from './_components/task/task-folder-nav/task-folder-nav.component';
import { TaskCalendarViewComponent } from './_components/task/task-calendar-view/task-calendar-view.component';
import { TaskBoardViewComponent } from './_components/task/task-board-view/task-board-view.component';
import { TaskGanttViewComponent } from './_components/task/task-gantt-view/task-gantt-view.component';
import { TaskTableViewComponent } from './_components/task/task-table-view/task-table-view.component';
import { TaskViewControlsComponent } from './_components/task/task-view-controls/task-view-controls.component';
import { TagSearchComponent } from './_components/_helpers/tag-search.component';
import { TaskReservationSelectComponent } from './_components/_helpers/task-reservation-select.component';
import { OwnerProfileGuestListComponent } from './_components/owner-profile-guest/owner-profile-guest-list/owner-profile-guest-list.component';
import { OwnerProfileGuestComponent } from './_components/owner-profile-guest/owner-profile-guest/owner-profile-guest.component';
import { JobListComponent } from './_components/job/job-list/job-list.component';
import { JobComponent } from './_components/job/job/job.component';
import { ReservationLedgerComponent } from './_components/reservation/components/reservation-ledger/reservation-ledger/reservation-ledger.component';
import { ReservationLedgerListComponent } from './_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';
import { ListingQualityStatusListComponent } from './_components/listing-quality-status/listing-quality-status-list/listing-quality-status-list.component';
import { ListingQualityStatusComponent } from './_components/listing-quality-status/listing-quality-status/listing-quality-status.component';
import { QualityTestDefinitionsListComponent } from './_components/quality-test-definitions/quality-test-definitions-list/quality-test-definitions-list.component';
import { QualityTestDefinitionFormComponent } from './_components/quality-test-definitions/quality-test-definition-form/quality-test-definition-form.component';
import { QualityTestFieldRegistryListComponent } from './_components/quality-test-definitions/quality-test-field-registry-list/quality-test-field-registry-list.component';
import { QualityTestDashboardComponent } from './_components/quality-test-definitions/quality-test-dashboard/quality-test-dashboard.component';
import { MsgCampaignListComponent } from './_components/msg-campaign/msg-campaign-list/msg-campaign-list.component';
import { MsgCampaignComponent } from './_components/msg-campaign/msg-campaign/msg-campaign.component';
import { MsgListComponent } from './_components/msg/msg-list/msg-list.component';
import { MsgComponent } from './_components/msg/msg/msg.component';
import { MsgRecipientListComponent } from './_components/msg-recipient/msg-recipient-list/msg-recipient-list.component';
import { MsgRecipientComponent } from './_components/msg-recipient/msg-recipient/msg-recipient.component';
import { QuestionAnswerListComponent } from './_components/question-answer/question-answer-list/question-answer-list.component';
import { QuestionAnswerComponent } from './_components/question-answer/question-answer/question-answer.component';
import { ReservationContainerComponent } from './_components/reservation/components/reservation/reservation-container/reservation-container.component';
import { FeaturesListComponent } from './_components/feature/feature-listing/feature-listing.component';
import { PropertyFeatureListComponent } from './_components/property/property-feature/property-feature-list/property-feature-list.component';
import { PropertyFeatureComponent } from './_components/property/property-feature/property-feature/property-feature.component';
import { FeatureAdminContainerComponent } from './_components/property/feature/feature-admin-container/feature-admin-container.component';
import { CodeProjectComponent } from './_components/code-project/code-project/code-project.component';
import { CodeProjectListComponent } from './_components/code-project/code-project-list/code-project-list.component';
import { CodeTaskComponent } from './_components/code-task/code-task/code-task.component';
import { CodeTaskListComponent } from './_components/code-task/code-task-list/code-task-list.component';
import { PropertyFeatureTemplateListComponent } from './_components/property/property-feature-template/property-feature-template-list/property-feature-template-list.component';
import { PropertyFeatureTemplateComponent } from './_components/property/property-feature-template/property-feature-template/property-feature-template.component';
import { GuestCampaignComponent } from './_components/guest-campaign/guest-campaign/guest-campaign.component';
import { GuestSearchTemplateComponent } from './_components/guest-campaign/search-template/guest-search-template.component';
import { PropertyFeatureTemplateDetailComponent } from './_components/property/property-feature-template/property-feature-template-detail/property-feature-template-detail.component';
import { PropertySummaryListComponent } from './_components/property/propery-summary-list/propery-summary-list.component';

import { OwnerStmtComponent } from './_components/owner-stmt/owner-stmt/owner-stmt.component';
import { OwnerStmtListComponent } from './_components/owner-stmt/owner-stmt-list/owner-stmt-list.component';
import { OwnerStmtRezComponent } from './_components/owner-stmt-rez/owner-stmt-rez/owner-stmt-rez.component';
import { OwnerStmtRezListComponent } from './_components/owner-stmt-rez/owner-stmt-rez-list/owner-stmt-rez-list.component';
import { OwnerStmtRezDetailComponent } from './_components/owner-stmt-rez-detail/owner-stmt-rez-detail/owner-stmt-rez-detail.component';
import { OwnerStmtRezDetailListComponent } from './_components/owner-stmt-rez-detail/owner-stmt-rez-detail-list/owner-stmt-rez-detail-list.component';
import { OwnerStmtExpComponent } from './_components/owner-stmt-exp/owner-stmt-exp/owner-stmt-exp.component';
import { OwnerStmtExpListComponent } from './_components/owner-stmt-exp/owner-stmt-exp-list/owner-stmt-exp-list.component';
import { OwnerStmtExpDetailComponent } from './_components/owner-stmt-exp-detail/owner-stmt-exp-detail/owner-stmt-exp-detail.component';
import { OwnerStmtExpDetailListComponent } from './_components/owner-stmt-exp-detail/owner-stmt-exp-detail-list/owner-stmt-exp-detail-list.component';
import { TaxPreviewDialogComponent } from './_components/owner-stmt/nacha/tax-preview-dialog/tax-preview-dialog.component';
import { NachaStepsDialogComponent } from './_components/owner-stmt/nacha/nacha-steps-dialog/nacha-steps-dialog.component';
import { ServiceProductComponent } from './_components/service-product/service-product/service-product.component';
import { ServiceProductListComponent } from './_components/service-product/service-product-list/service-product-list.component';
import { StatementsComponent } from './_components/owner-stmt-view/statements/statements.component';
import { CompleteLetterDialogComponent } from './_components/owner-stmt-view/statements/complete-letter-dialog.component';
import { StatementsTaxBreakdownDialogComponent } from './_components/owner-stmt-view/statements/statements-tax-breakdown-dialog.component';
import { StatementAmountPipe } from './_components/_helpers/statement-amount.pipe';

import { CostProfileListComponent } from './_components/cost-profile/cost-profile-list/cost-profile-list.component';
import { CostProfileComponent } from './_components/cost-profile/cost-profile/cost-profile.component';
import { ChartAccountComponent } from './_components/chart-account/chart-account/chart-account.component';
import { ChartAccountListComponent } from './_components/chart-account/chart-account-list/chart-account-list.component';
// import { RentalIncomeViewComponent } from './_components/rental-income-view/rental-income-view.component';
import { PropertyConditionListComponent } from './_components/property-condition/property-condition-list/property-condition-list.component';
import { PropertyConditionComponent } from './_components/property-condition/property-condition/property-condition.component';
import { RUPropertiesStatusListComponent } from './_components/ru-properties-status/ru-properties-status-list/ru-properties-status-list.component';
import { RUPropertiesStatusComponent } from './_components/ru-properties-status/ru-properties-status/ru-properties-status.component';

// proforma
import { ProformaComponent } from './_components/proforma/proforma/proforma.component';
import { ProformaListComponent } from './_components/proforma/proforma-list/proforma-list.component';
import { ProformaExpenseComponent } from './_components/proforma-expense/proforma-expense/proforma-expense.component';
import { ProformaExpenseListComponent } from './_components/proforma-expense/proforma-expense-list/proforma-expense-list.component';
import { ProformaIncomeComponent } from './_components/proforma-income/proforma-income/proforma-income.component';
import { ProformaIncomeListComponent } from './_components/proforma-income/proforma-income-list/proforma-income-list.component';
import { NoteListComponent } from './_components/task/note/note-list/note-list.component';
import { PropertyLeadProfileComponent } from './_components/property-lead-profile/property-lead-profile/property-lead-profile.component';
import { PropertyLeadProfileListComponent } from './_components/property-lead-profile/property-lead-profile-list/property-lead-profile-list.component';
import { RealtorProfileComponent } from './_components/realtor-profile/realtor-profile/realtor-profile.component';
import { RealtorProfileListComponent } from './_components/realtor-profile/realtor-profile-list/realtor-profile-list.component';
import { OwnerLeadProfileComponent } from './_components/owner-lead-profile/owner-lead-profile/owner-lead-profile.component';
import { OwnerLeadProfileListComponent } from './_components/owner-lead-profile/owner-lead-profile-list/owner-lead-profile-list.component';
import { ArticleComponent } from './_components/article/article/article.component';
import { ArticleListComponent } from './_components/article/article-list/article-list.component';
import { ContentListComponent } from './_components/content/content-list/content-list.component';
import { ContentOpsComponent } from './_components/content-ops/content-ops.component';
import { ContentFormComponent } from './_components/content/content-form/content-form.component';
import { MediaTabComponent } from './_components/content/content-form/media-tab/media-tab.component';
import { ContentGenerateComponent } from './_components/content/content-generate/content-generate.component';
import { ProformaViewComponent } from './_components/proforma-view/proforma-view.component';
import { ProformaCopyToFormComponent } from './_components/proforma/proforma-copy-to-form/proforma-copy-to-form.component';
import { ProformaTargetComponent } from './_components/proforma-view/proforma-target/proforma-target.component';
import { ProformaTemplateComponent } from './_components/proforma-template/proforma-template/proforma-template.component';
import { ProformaTemplateListComponent } from './_components/proforma-template/proforma-template-list/proforma-template-list.component';


// Tinymce
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { ResSalesDashboardComponent } from './_components/report/components/res-sales-dashboard/res-sales-dashboard.component';
import { ResSalesSummaryComponent } from './_components/report/components/res-sales-summary/res-sales-summary.component';
import { ResSalesOnholdComponent } from './_components/report/components/res-sales-onhold/res-sales-onhold.component';
import { ResSalesAgentComponent } from './_components/report/components/res-sales-agent/res-sales-agent.component';
import { ResSalesDevelopmentComponent } from './_components/report/components/res-sales-development/res-sales-development.component';
import { ResSalesDetailsByYearDashboardComponent } from './_components/report/components/res-sales-details-by-year-dashboard/res-sales-details-by-year-dashboard.component';
import { SalesByLocationComponent } from './_components/report/components/sales-by-location/sales-by-location.component';
import { SalesByPropertyComponent } from './_components/report/components/sales-by-property/sales-by-property.component';
import { SalesByChannelComponent } from './_components/report/components/sales-by-channel/sales-by-channel.component';
import { SalesReportStatisticsComponent } from './_components/report/components/sales-report-statistics/sales-report-statistics.component';
import { BizDevDashboardComponent } from './_components/report/components/biz-dev-dashboard/biz-dev-dashboard.component';
import { DevelopmentDetailsComponent } from './_components/report/components/development-details/development-details.component';
import { BizDevPropertyDevelopmentComponent } from './_components/report/components/biz-dev-property-development/biz-dev-property-development.component';
import { BizDevPropertyLocationComponent } from './_components/report/components/biz-dev-property-location/biz-dev-property-location.component';
import { BizDevPropertyBedroomComponent } from './_components/report/components/biz-dev-property-bedroom/biz-dev-property-bedroom.component';
import { LocationDetailsComponent } from './_components/report/components/location-details/location-details.component';
import { ChannelDetailsComponent } from './_components/report/components/channel-details/channel-details.component';
import { AgentDetailsComponent } from './_components/report/components/agent-details/agent-details.component';
import { AdminDashboardComponent } from './_components/admin-dashboard/admin-dashboard.component';
import { OccupancyDashboardComponent } from './_components/report/components/occupancy-dashboard/occupancy-dashboard.component';
import { OwnerMgmtCmsListComponent } from './_components/owner-management/owner-management-list/owner-management-list.component';
import { OwnerMgmtCmsComponent } from './_components/owner-management/owner-management/owner-management.component';
import { MaintenanceEventListComponent } from './_components/maintenance-event/maintenance-event-list/maintenance-event-list.component';
import { MaintenanceEventComponent } from './_components/maintenance-event/maintenance-event/maintenance-event.component';
import { MaintenanceEventShortTermRentalListComponent } from './_components/maintenance-event-shorttermrental/maintenance-event-shorttermrental-list/maintenance-event-shorttermrental-list.component';
import { MaintenanceEventShortTermRentalComponent } from './_components/maintenance-event-shorttermrental/maintenance-event-shorttermrental/maintenance-event-shorttermrental.component';
import { FutureOccupancyDashboardComponent } from './_components/report/components/future-occupancy-dashboard/future-occupancy-dashboard.component';
import { OperationsDashboardComponent } from './_components/report/components/operations-dashboard/operations-dashboard.component';
import { OperationsDrilldownDialogComponent } from './_components/report/components/operations-dashboard/operations-drilldown-dialog.component';
import { OperationsDrilldownPageComponent } from './_components/report/components/operations-drilldown-page/operations-drilldown-page.component';
import { OperationsDashboardShellComponent } from './_components/report/components/operations-dashboard-shell/operations-dashboard-shell.component';
import { ReservationsDashboardShellComponent } from './_components/reservations-dashboard-shell/reservations-dashboard-shell.component';
import { GuestArrivalListComponent } from './_components/guest-arrival/components/guest-arrival-list/guest-arrival-list.component';
import { SmsComponent } from './_components/guest-arrival/components/sms/sms.component';
import { ArrivalsBoardComponent } from './_components/arrivals-board/arrivals-board.component';
import { ArrivalsSmsDialogComponent } from './_components/arrivals-board/arrivals-sms-dialog/arrivals-sms-dialog.component';
import { ArrivalsAgentBoardComponent } from './_components/arrivals-agent/arrivals-agent-board.component';
import { EmployeeAcqPaymentComponent } from './_components/employee-acq-payment/employee-acq-payment/employee-acq-payment.component';
import { EmployeeAcqPaymentListComponent } from './_components/employee-acq-payment/employee-acq-payment-list/employee-acq-payment-list.component';
import { EmployeeProfileComponent } from './_components/employee-profile/employee-profile/employee-profile.component';
import { EmployeeProfileListComponent } from './_components/employee-profile/employee-profile-list/employee-profile-list.component';
import { QuartzJobListComponent } from './_components/quartz-job/quartz-job-list/quartz-job-list.component';
import { MsgTemplateListComponent } from './_components/msg-template/msg-template-list/msg-template-list.component';
import { MsgTemplateComponent } from './_components/msg-template/msg-template/msg-template.component';
import { OwnerReviewListComponent } from './_components/owner-review/components/owner-review-list/owner-review-list.component';
import { OwnerReviewComponent } from './_components/owner-review/components/owner-review/owner-review.component';
import { EmployeePtoListComponent } from './_components/employee-pto/employee-pto-list/employee-pto-list.component';
import { EmployeePtoComponent } from './_components/employee-pto/employee-pto/employee-pto.component';
import { EmployeePtoRequestComponent } from './_components/employee-pto/employee-pto-request/employee-pto-request.component';
import { WifiQrComponent } from './_components/wifi-qr/wifi-qr.component';
import { FeaturePivotSummaryComponent } from './_components/feature/feature-pivot-summary/feature-pivot-summary.component';
import { SendFullMailComponent } from '@app/_components/msg/send-full-mail/send-full-mail.component';
import { CreateUserComponent } from '@app/_components/user/create-user/create-user.component';
import { BizdevDashboardComponent } from './_components/bizdev-dashboard/bizdev-dashboard.component';
import { BizdevHomeComponent } from './_components/bizdev-home/bizdev-home.component';
import { BizdevLookupAdminComponent } from './_components/bizdev-lookup-admin/bizdev-lookup-admin.component';
import { BizdevPipelineComponent } from './_components/bizdev-pipeline/bizdev-pipeline.component';
import { BizdevComposeDialogComponent } from './_components/bizdev-pipeline/bizdev-compose-dialog/bizdev-compose-dialog.component';
import { VehicleBookingComponent } from './_components/vehicle-booking/vehicle-booking/vehicle-booking.component';
import { VehicleBookingListComponent } from './_components/vehicle-booking/vehicle-booking-list/vehicle-booking-list.component';
import { ImapConfigurationListComponent } from '@app/_components/imap-configuration/imap-configuration-list/imap-configuration-list.component';
import { ImapConfigurationComponent } from '@app/_components/imap-configuration/imap-configuration/imap-configuration.component';
import { InboxComponent } from '@app/_components/inbox/inbox/inbox.component';
import { InboxListComponent } from '@app/_components/inbox/inbox-list/inbox-list.component';
import { RealEstateListComponent } from '@app/_components/real-estate/real-estate-list/real-estate-list.component';
import { RealEstateComponent } from '@app/_components/real-estate/real-estate/real-estate.component';
import { Contact } from '@app/_components/contact';
import { ContactListComponent } from '@app/_components/contact/contact-list/contact-list.component';
import { ContactComponent } from '@app/_components/contact/contact/contact.component';
import { ImportContactComponent } from '@app/_components/contact/import-contact/import-contact.component';
import { MsgHistoryComponent } from '@app/_components/msg/msg-history/msg-history.component';
import { FaqListComponent } from './_components/faq/faq-list/faq-list.component';
import { FaqComponent } from './_components/faq/faq/faq.component';
import { FaqSectionListComponent } from './_components/faq-section/faq-section-list/faq-section-list.component';
import { FaqSectionComponent } from './_components/faq-section/faq-section/faq-section.component';
import { FaqCategoryListComponent } from './_components/faq-category/faq-category-list/faq-category-list.component';
import { FaqCategoryComponent } from './_components/faq-category/faq-category/faq-category.component';
import { MktgLetterComponent } from './_components/mktg-letter/mktg-letter/mktg-letter.component';
import { MktgLetterListComponent } from './_components/mktg-letter/mktg-letter-list/mktg-letter-list.component';
import { BlogComponent } from './_components/blog/blog/blog.component';
import { BlogListComponent } from './_components/blog/blog-list/blog-list.component';
import { ImapUserMappingComponent } from '@app/_components/imap-user-mapping/imap-user-mapping/imap-user-mapping.component';
import { ProformaCopyFromFormComponent } from './_components/proforma/proforma-copy-from-form/proforma-copy-from-form.component';
import { ProformaGeneratesComponent } from './_components/proforma/Proforma-generates/proforma-generates.component';
import { ProformaGeneratedListComponent } from './_components/proforma/proforma-generated-list/proforma-generated-list.component';
import { OwnerPropertyComponent } from './_components/owner-lead-profile/owner-property-details/owner-property-details.component';
import { OwnerPropertyListComponent } from './_components/owner-lead-profile/owner-property-details-list/owner-property-details-list.component';
import { ContactSelectComponent } from '@app/_components/contact/contact-select/contact-select.component';
import { UserSearchComponent } from '@app/_components/user/user-search/user-search.component';
import { TeamSearchComponent } from '@app/_components/user/team-search/team-search.component';
import { YieldMaxComponent } from './_components/yield-max/yield-max.component';
import { PropertiesListComponent } from './_components/yield-max/property/property-list/property-list.component';
import { PropertiesComponent } from './_components/yield-max/property/property/property.component';
import { ReservationsComponent } from './_components/yield-max/reservation/reservation/reservation.component';
import { ReservationsListComponent } from './_components/yield-max/reservation/reservation-list/reservation-list.component';
import { RateBucketsListComponent } from './_components/yield-max/rate-bucket/rate-bucket-list/rate-bucket-list.component';
import { RateBucketsComponent } from './_components/yield-max/rate-bucket/rate-bucket/rate-bucket.component';
import { RateSeasonComponent } from './_components/yield-max/rate-season/rate-season/rate-season.component';
import { RateSeasonListComponent } from './_components/yield-max/rate-season/rate-season-list/rate-season-list.component';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';
import { ImportDataComponent } from '@app/_components/_helpers/import-export/import-data/import-data.component';
import { ArrivalDepartureReportComponent } from './_components/report/reports/arrival-departure-report/arrival-departure-report.component';
import { TapeChartListComponent } from './_components/yield-max/tape-chart/tape-chart-list/tape-chart-list.component';
import { TapeChartComponent } from './_components/yield-max/tape-chart/tape-chart/tape-chart.component';
import { TapeChartListCellEditComponent } from './_components/yield-max/tape-chart/tape-chart-list-cell-edit/tape-chart-list-cell-edit.component';
import { OrderTaxListComponent } from './_components/order-tax/order-tax-list/order-tax-list.component';
import { OrderTaxComponent } from './_components/order-tax/order-tax/order-tax.component';
import { OrderProductShortTermRentalJoinListComponent } from './_components/order-products-short-term-rental-join/order-products-short-term-rental-join-list/order-products-short-term-rental-join-list.component';
import { OrderProductShortTermRentalJoinComponent } from './_components/order-products-short-term-rental-join/order-products-short-term-rental-join/order-products-short-term-rental-join.component';
import { OrderProductTaxJoinListComponent } from './_components/order-product-tax-join/order-product-tax-join-list/order-product-tax-join-list.component';
import { OrderProductTaxJoinComponent } from './_components/order-product-tax-join/order-product-tax-join/order-product-tax-join.component';
import { GuestExitSurveyComponent } from './_components/guest-exit-survey/guest-exit-surveyest/guest-exit-survey.component';
import { GuestExitSurveyListComponent } from './_components/guest-exit-survey/guest-exit-survey-list/guest-exit-survey-list.component';
import { GuestRequestListComponent } from './_components/guest-request-list/guest-request-list.component';
import { OrderTaxShortTermRentalJoinListComponent } from './_components/order-tax-short-term-rental-join/order-tax-short-term-rental-join-list/order-tax-short-term-rental-join-list.component';
import { OrderTaxShortTermRentalJoinComponent } from './_components/order-tax-short-term-rental-join/order-tax-short-term-rental-join/order-tax-short-term-rental-join.component';
import { PropertyConfigComponent } from './_components/yield-max/property-config/property-config.component';
import { TeamListComponent } from '@app/_components/team/team-list/team-list.component';
import { TeamComponent } from '@app/_components/team/team/team.component';
import { TeamUserSelectComponent } from '@app/_components/team/team-user-select/team-user-select.component';
import { RateSeasonSummaryComponent } from './_components/yield-max/rate-season/rate-season-summary/rate-season-summary.component';
import { QualityTestComponent } from './_components/yield-max/quality-test/quality-test/quality-test.component';
import { QualityTestListComponent } from './_components/yield-max/quality-test/quality-test-list/quality-test-list.component';
import { YieldmaxAdminComponent } from './_components/yield-max/yieldmax-admin/yieldmax-admin.component';
import { RUReservationsListComponent } from './_components/ru-reservations/ru-reservations-list/ru-reservations-list.component';
import { RUReservationsComponent } from './_components/ru-reservations/ru-reservations/ru-reservations.component';
import { RateDetailBulkEditComponent } from './_components/yield-max/rate-detail-bulk-edit/rate-detail-bulk-edit.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { PropertyListDetailsComponent } from './_components/property/property-list-details/property-list-details.component';
import { OrderDetailTaxListComponent } from './_components/reservation/components/reservation/order-detail-tax/order-detail-tax-list/order-detail-tax-list.component';
import { OrderDetailTaxComponent } from './_components/reservation/components/reservation/order-detail-tax/order-detail-tax/order-detail-tax.component';
import { PublicTaskListComponent } from '@app/_components/task/public-task-list/public-task-list.component';
import { TaskSearchComponent } from '@app/_components/task/task-search/task-search.component';
import { TagListComponent } from '@app/_components/tag/tag-list/tag-list.component';
import { TagComponent } from '@app/_components/tag/tag/tag.component';
import { TagCategoryManageDialogComponent } from '@app/_components/tag/tag-category-manage-dialog/tag-category-manage-dialog.component';
// OP coverage audit dialog — replaces the standalone OP→Tag mapping page. Surfaces
// only the gap-finding feature (which OPs have no tag wired) since everything else
// it used to do is already on the Tag List.
import { OpCoverageDialogComponent } from '@app/_components/tag/op-coverage-dialog/op-coverage-dialog.component';
import { TrackedLinkListComponent } from '@app/_components/tracked-link/tracked-link-list/tracked-link-list.component';
import { TrackedLinkFormComponent } from '@app/_components/tracked-link/tracked-link/tracked-link.component';
import { LinkAnalyticsComponent } from '@app/_components/tracked-link/link-analytics/link-analytics.component';
import { CampaignAnalyticsComponent } from '@app/_components/tracked-link/campaign-analytics/campaign-analytics.component';
import { TemplateAnalyticsComponent } from '@app/_components/tracked-link/template-analytics/template-analytics.component';
import { AppEventListComponent } from '@app/_components/app-event/app-event-list.component';
import { AppEventDetailComponent } from '@app/_components/app-event/app-event-detail.component';
import { MsgUnsubscribeListComponent } from './_components/msg-unsubscribe/msg-unsubscribe-list/msg-unsubscribe-list.component';
import { MsgUnsubscribeComponent } from './_components/msg-unsubscribe/msg-unsubscribe/msg-unsubscribe.component';
import { TapeChartWikiListComponent } from './_components/tape-chart-wiki/tape-chart-wiki-list/tape-chart-wiki-list.component';
import { TapeChartWikiComponent } from './_components/tape-chart-wiki/tape-chart-wiki/tape-chart-wiki.component';
import { BestFitListComponent } from './_components/best-fit/best-fit-list/best-fit-list.component';
import { BflHelpDialogComponent } from './_components/best-fit/bfl-help-dialog/bfl-help-dialog.component';
import { InboxListVerticalComponent } from '@app/_components/inbox/inbox-list-vertical/inbox-list-vertical.component';
import { OrderListComponent } from './_components/order/order-list/order-list.component';
import { OrderComponent } from './_components/order/order/order.component';
import { OpsDashboardComponent } from './_components/yield-max/ops-dashboard/ops-dashboard/ops-dashboard.component';
import { InboxSmsComponent } from '@app/_components/inbox/inbox-sms/inbox-sms.component';
import { InboxMailSMsComponent } from '@app/_components/inbox/inbox-mail-sms/inbox-mail-sms.component';
import { EmailDirectoryComponent } from '@app/_components/inbox/email-directory/email-directory.component';
import { ConversationComponent } from '@app/_components/inbox/conversation/conversation.component';
import { HelpComponent } from '@app/_components/help/help/help.component';
import { HelpListComponent } from '@app/_components/help/help-list/help-list.component';
import { HelpLinkComponent } from '@app/_components/help/help-link/help-link.component';
import { ReservationCreateComponent } from './_components/reservation/components/reservation-create/reservation-create.component';
import { LogmanYieldMaxListComponent } from './_components/yield-max/logman-yieldmax/components/logman-yieldmax-list/logman-yieldmax-list.component';
import { LogmanYieldMaxComponent } from './_components/yield-max/logman-yieldmax/components/logman-yieldmax/logman-yieldmax.component';
import { CompareWikiReservationListComponent } from './_components/compare-wiki-reservation/compare-wiki-reservation-list/compare-wiki-reservation-list.component';
import { QuickTaskComponent } from '@app/_components/task/quick-task/quick-task.component';
import { InboxListGuestComponent } from '@app/_components/inbox/inbox-list-guest/inbox-list-guest.component';
import { RateComponent } from './_components/yield-max/rate-yieldmax/rate-yieldmax/rate-yieldmax.component';
import { RateListComponent } from './_components/yield-max/rate-yieldmax/rate-yieldmax-list/rate-yieldmax-list.component';
import { RatesLosComponent } from './_components/yield-max/ratelos-yieldmax/ratelos-yieldmax/ratelos-yieldmax.component';
import { RatesLosListComponent } from './_components/yield-max/ratelos-yieldmax/ratelos-yieldmax-list/ratelos-yieldmax-list.component';
import { ReservationInvoiceComponent } from './_components/reservation-invoice/reservation-invoice.component';
import { CompendiumListComponent } from './_components/compendium/compendium-list/compendium-list.component';
import { CompendiumComponent } from './_components/compendium/compendium/compendium.component';
import { SearchTemplateMsgComponent } from '@app/_components/report/search-template-msg/search-template-msg.component';
import { CheckDoubleBookingListComponent } from "./_components/check-double-booking/check-double-booking-list/check-double-booking-list.component";
import { CompendiumShortTermRentalJoinListComponent } from './_components/compendium-short-term-rental-join/compendiums-short-term-rental-join-list/compendiums-short-term-rental-join-list.component';
import { CompendiumShortTermRentalJoinComponent } from './_components/compendium-short-term-rental-join/compendiums-short-term-rental-join/compendiums-short-term-rental-join.component';
import { GuestMasterProfileListComponent } from './_components/guest-master-profile/guest-master-profile-list/guest-master-profile-list.component';
import { GuestMasterProfileComponent } from './_components/guest-master-profile/guest-master-profile/guest-master-profile.component';
import { ReservationLedgerListSummaryComponent } from './_components/reservation/components/reservation-ledger-list-summary/reservation-ledger-list-summary.component';
import { ReservationLedgerListSummaryComponentOld } from './_components/reservation/components/reservation-ledger-list-summary-old/reservation-ledger-list-summary.component-old';
import { PropertyCompendiumComponent } from './_components/compendium/property-compendium/property-compendium.component';
import { RateReportComponent } from './_components/yield-max/ops-dashboard/rates-report/rates-report.component';
import {
	CompareReservationLedgerListComponent
} from "@app/_components/compare-reservation-ledger/compare-reservation-ledger-list/compare-reservation-ledger-list.component";
import {
	RuAvailabilityValidateListComponent
} from "@app/_components/ru-availability-validate/ru-availability-validate-list/ru-availability-validate-list.component";
import { ReservationAdvanceSearchComponent } from './_components/reservation/components/reservation-advance-search/reservation-advance-search.component';
import { QuoteListComponent } from './_components/quote/quote-list/quote-list.component';
import { QuoteComponent } from './_components/quote/quote/quote.component';
import { AdditionalPaymentComponent } from './_components/reservation/components/reservation/additional-payment/additional-payment.component';
import { ReconcileCapturedPopupComponent } from './_components/reservation/components/reservation/reconcile-captured-popup/reconcile-captured-popup.component';
import { OrderInvoiceDetailComponent } from './_components/reservation/components/reservation/order-invoice-detail/order-invoice-detail/order-invoice-detail.component';
import { OrderInvoiceDetailListComponent } from './_components/reservation/components/reservation/order-invoice-detail/order-invoice-detail-list/order-invoice-detail-list.component';
import { ReservationLedgerSummaryComponent } from './_components/reservation/components/reservation-ledger-summary/reservation-ledger-summary.component';
import { NotesChatModule } from './_components/_shared/notes-chat/notes-chat.module';
import { OwnerStatementsComponent } from './_components/owner-statements/owner-statements.component';
import { StatementDashboardComponent } from './_components/owner-statements/statement-dashboard/statement-dashboard.component';
import { NachaToolsDialogComponent } from './_components/owner-statements/nacha-tools-dialog/nacha-tools-dialog.component';
import { StatementProductionGuideComponent } from './_components/owner-statements/statement-production-guide/statement-production-guide.component';
import { StatementComponent } from './_components/owner-statements/statement/statement.component';
import { StatementDetailComponent } from './_components/owner-statements/statement-detail/statement-detail.component';
import { StatementDetailListComponent } from './_components/owner-statements/statement-detail-list/statement-detail-list.component';
import { StatementCreateComponent } from './_components/owner-statements/statement-create/statement-create.component';
import { AddStatementDetailComponent } from './_components/owner-statements/add-statement-detail/add-statement-detail.component';
import { EditQuoteComponent } from './_components/quote/edit-quote/edit-quote.component';
import { ReservationBalanceDueComponent } from './_components/reservation/components/reservation-balance-due/reservation-balance-due.component';
import { ReservationInOutListComponent } from './_components/reservation/components/reservation-in-out-list/reservation-in-out-list.component';
import { WelcomeCardDialogComponent } from './_components/reservation/components/welcome-card-dialog/welcome-card-dialog.component';
import { ReservationReportComponent } from './_components/yield-max/ops-dashboard/reservation-report/reservation-report/reservation-report.component';
import { ExpenseDetail } from '@app/_components/expense/components/expense-detail/expense-detail';
import { ExpenseDetailListComponent } from '@app/_components/expense/components/expense-detail/expense-detail-list/expense-detail-list.component';
import { ExpenseDetailComponent } from '@app/_components/expense/components/expense-detail/expense-detail/expense-detail.component';
import { ExpenseComponent } from '@app/_components/expense/expense/expense.component';
import { StyleguideComponent } from './_components/styleguide/styleguide.component';
import { AdminStyleguideComponent } from './_components/admin-styleguide/admin-styleguide.component';
import { ExpenseListComponent } from '@app/_components/expense/expense-list/expense-list.component';
import { ExpenseAdvanceSearchComponent } from './_components/expense/expense-advance-search/expense-advance-search.component';

import { PropertyProfileOffboardingListComponent } from './_components/property-profile-offboarding-list/property-profile-offboarding-list.component';
import { PropertyProfileOnboardingListComponent } from './_components/property-profile-onboarding-list/property-profile-onboarding-list.component';
import { OnboardingTasksDialogComponent } from './_components/property-profile-onboarding-list/onboarding-tasks-dialog/onboarding-tasks-dialog.component';
import { ResADRReportComponent } from './_components/report/reports/res-adr-report/res-adr-report.component';
import { TagRevenueReportComponent } from './_components/report/reports/tag-revenue-report/tag-revenue-report.component';
import { CompositeListingListComponent } from './_components/composite-listing/composite-listing-list/composite-listing-list.component';
import { CompositeListingComponent } from './_components/composite-listing/composite-listing/composite-listing.component';
import { HotelListingListComponent } from './_components/hotel-listing/hotel-listing-list/hotel-listing-list.component';
import { HotelListingComponent } from './_components/hotel-listing/hotel-listing/hotel-listing.component';
import { ChangeHistoryListComponent } from './_components/yield-max/change-history/change-history-list/change-history-list.component';
import { HousekeepingReportListComponent } from '@app/_components/housekeeping-report/housekeeping-report-list/housekeeping-report-list.component';
import { ReportReservationComponent } from '@app/_components/housekeeping-report/report-reservation/report-reservation.component';
import { RollawayBadComponent } from '@app/_components/housekeeping-report/rollaway-bad/rollaway-bad.component';
import { FutonBadComponent } from '@app/_components/housekeeping-report/futon-bad/futon-bad.component';
import { OpenUnitComponent } from '@app/_components/housekeeping-report/open-unit/open-unit.component';
import { InterimCleaningComponent } from '@app/_components/housekeeping-report/interim-cleaning/interim-cleaning.component';
import { LinenServiceComponent } from '@app/_components/housekeeping-report/linen-service/linen-service.component';
import { TravelAgentProfileListComponent } from './_components/travel-agent-profile/travel-agent-profile-list/travel-agent-profile-list.component';
import { TravelAgentProfileComponent } from './_components/travel-agent-profile/travel-agent-profile/travel-agent-profile.component';
import { OccMapListComponent } from './_components/yield-max/occ-map/occ-map-list/occ-map-list.component';
import { OccMatrixListComponent } from './_components/yield-max/occ_matrix/occ_matrix-list/occ_matrix-list.component';
import { OccProfileListComponent } from './_components/yield-max/occ-profile/occ-profile-list/occ-profile-list.component';
import { OccDeviationListComponent } from './_components/yield-max/occ-deviation/occ-deviation-list/occ-deviation-list.component';
import { OccDaysToArrivalListComponent } from './_components/yield-max/occ_days_to_arrival/occ_days_to_arrival-list/occ_days_to_arrival-list.component';
import { OccMapComponent } from './_components/yield-max/occ-map/occ-map/occ-map.component';
import { OccMatrixComponent } from './_components/yield-max/occ_matrix/occ_matrix/occ_matrix.component';
import { OccProfileComponent } from './_components/yield-max/occ-profile/occ-profile/occ-profile.component';
import { OccDeviationComponent } from './_components/yield-max/occ-deviation/occ-deviation/occ-deviation.component';
import { OccDaysToArrivalComponent } from './_components/yield-max/occ_days_to_arrival/occ_days_to_arrival/occ_days_to_arrival.component';
import { OccDaysMatrixComponent } from './_components/yield-max/occ_matrix_ui/occ_matrix_ui/occ-days-matrix.component';
import { AddDayDialogComponent } from './_components/yield-max/occ_matrix_ui/add-day-dialog/add-day-dialog.component';
import { ResMasterComponent } from './_components/report/reports/res-master/res-master.component';
import { DataReportComponent } from './_components/data-report/data-report/data-report.component';
import { ResMasterEscrowComponent } from './_components/report/reports/res-master-escrow/res-master-escrow.component';
import { TravelInsuranceReportComponent } from './_components/report/reports/travel-insurance-report/travel-insurance-report.component';
import { NotesChatComponent } from './_components/_shared/notes-chat/notes-chat.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaymentConfirmComponent } from './_components/payment-confirm/payment-confirm/payment-confirm.component';
import { PaymentConfirmListComponent } from './_components/payment-confirm/payment-confirm-list/payment-confirm-list.component';
import { RateSeasonMonthlySummaryComponent } from './_components/yield-max/rate-season/rate-season-summary-monthly/rate-season-monthly-summary.component';
import { AiAgentListComponent } from './_components/ai-agent/ai-agent-list/ai-agent-list.component';
import { AiAgentComponent } from './_components/ai-agent/ai-agent/ai-agent.component';
import { LandingPageCMSListComponent } from './_components/landing-page-cms/landing-page-cms-list/landing-page-cms-list.component';
import { LandingPageCMSComponent } from './_components/landing-page-cms/landing-page-cms/landing-page-cms.component';
import { AccessCodeListComponent } from './_components/access-code/access-code-list/access-code-list.component';
import { AccessCodeComponent } from './_components/access-code/access-code/access-code.component';
import { OccDayDetailsDialogComponent } from './_components/yield-max/occ_matrix_ui/occ-day-details-dialog/occ-day-details-dialog.component';
import { AiDialogComponent } from './_components/ai/ai-dialog/ai-dialog.component';
import { CancelsByPropertyComponent } from './_components/report/components/res-cancel-by-property/res-cancel-by-property.component';
import { HoldsByPropertyComponent } from './_components/report/components/res-hold-by-property/res-hold-by-property.component';
import { HoldsExpireByPropertyComponent } from './_components/report/components/res-hold-expire-by-property/res-hold-expire-by-property.component';
import { UpsellDashboardComponent } from './_components/report/components/upsell-dashboard/upsell-dashboard.component';
import { OwnerStatementsReconsiliationComponent } from './_components/owner-statements/owner-statements-reconsiliation/owner-statements-reconsiliation.component';
import { MonthlyStmtExpensesComponent } from './_components/owner-statements/monthly-stmt-expenses/monthly-stmt-expenses.component';
import { ViewPropertyCompendiumComponent } from './_components/view-compendium/property-view-compendium.component';
import { BlogDevelopmentListComponent } from './_components/blog-development/blog-development-list/blog-development-list.component';
import { BlogDevelopmentComponent } from './_components/blog-development/blog-development/blog-development.component';
import { FutureOccupancyReportComponent } from './_components/report/reports/future-occupancy-report/future-occupancy-report.component';
import { AnalyticsDashboardComponent } from './_components/report/reports/analytics-dashboard/analytics-dashboard.component';
import { QuoteAnalyticsComponent } from './_components/report/reports/quote-analytics/quote-analytics.component';
import { UnifiedInboxComponent } from './unified-inbox/unified-inbox.component';
import { DripCampaignTemplateListComponent } from './_components/drip/drip-campaign-template-list/drip-campaign-template-list.component';
import { DripCampaignTemplateEditComponent } from './_components/drip/drip-campaign-template-edit/drip-campaign-template-edit.component';
import { DripCampaignInstanceListComponent } from './_components/drip/drip-campaign-instance-list/drip-campaign-instance-list.component';
import { DripCampaignInstanceDetailComponent } from './_components/drip/drip-campaign-instance-detail/drip-campaign-instance-detail.component';
import { UnifiedThreadComponent } from './unified-inbox/unified-thread/unified-thread.component';
import { UnifiedBubbleComponent } from './unified-inbox/unified-bubble/unified-bubble.component';
import { GuestHistoryPaneComponent } from './unified-inbox/guest-history-pane/guest-history-pane.component';
import { NoteComposerComponent } from './unified-inbox/note-composer/note-composer.component';
import { AllMessagesListComponent } from './unified-inbox/all-messages-list/all-messages-list.component';
import { QbSyncListComponent } from './_components/qb-sync/qb-sync-list.component';

// Phase 0 — Field Ops Platform
import { VendorListComponent } from './_components/vendor/vendor-list/vendor-list.component';
import { VendorEditComponent } from './_components/vendor/vendor-edit/vendor-edit.component';
import { TaskTemplateListComponent } from './_components/task-template/template-list/template-list.component';
import { TaskTemplateEditComponent } from './_components/task-template/template-edit/template-edit.component';
import { ServiceDetailRollupComponent } from './_components/task-service-detail/service-detail-rollup/service-detail-rollup.component';

// Marketing Dashboard
import { MarketingDashboardComponent } from './_components/marketing-dashboard/marketing-dashboard.component';
import { GuestTabComponent } from './_components/marketing-dashboard/guest-tab/guest-tab.component';
import { KpiSnapshotComponent } from './_components/marketing-dashboard/guest-tab/kpi-snapshot/kpi-snapshot.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@environments/environment';

@Injectable()
export class MyErrorHandler extends ErrorHandler {
	constructor(private primengConfig: PrimeNGConfig) {
		super();
	}
	ngOnInit() {
		this.primengConfig.ripple = true;
	}

	handleError(error) {
		super.handleError(error);
		console.log('Error occurred: ' + error.message);
	}
}

// used to control appearance of all forms from https://codinglatte.com/posts/angular/angular-material-form-field-appearance/
const appearance: MatFormFieldDefaultOptions = {
	appearance: 'fill'
};

/**
 * Components are declared, Modules are imported, and Services are provided. An example I'm working with:
 */

@NgModule({ imports: [AiDialogModule,
        PrimeNgDialogAppendDirective,
        TinyMceDialogAppendDirective,
        AgGridModule,
        TreeModule,
        ImageModule,
        KnobModule,
        DynamicDialogModule,
        DividerModule,
        BlockUIModule,
        ProgressSpinnerModule,
        BrowserModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CheckboxModule,
        ChipsModule,
        ConfirmDialogModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        InputMaskModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        MegaMenuModule,
        MenuModule,
        SpeedDialModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        SelectButtonModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TagModule,
        CardModule,
        ProgressSpinnerModule,
        SpinnerModule,
        BlockUIModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        routing,
        CalendarModule,
        SliderModule,
        TooltipModule,
        MatDialogModule,
        ListboxModule,
        DataViewModule,
        DialogModule,
        ButtonModule,
        MessageModule,
        ToastModule,
        ConfirmDialogModule,
        DropdownModule,
        InputTextModule,
        TableModule,
        CommonModule,
        MultiSelectModule,
        MatSnackBarModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        MatInputModule,
        MatDatepickerModule,
        MatMomentDateModule,
        ChipsModule,
        AutoCompleteModule,
        CheckboxModule,
        MatIconModule,
        DragDropModule,
        ClipboardModule,
        EditorModule,
        ChartModule,
        TreeTableModule,
        MatButtonToggleModule,
        MatRadioModule,
        NotesChatModule,
        OverlayPanelModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          registrationStrategy: 'registerWhenStable:30000'
        })], declarations: [
        QuartzJobListComponent,
        TaskHomeComponent,
        TaskFolderNavComponent,
        TaskCalendarViewComponent,
        TaskBoardViewComponent,
        TaskGanttViewComponent,
        TaskTableViewComponent,
        TaskViewControlsComponent,
        TagSearchComponent,
        PropertyImageVertLayoutComponent,
        TestComponent,
        TestListComponent,
        TestListCellEditComponent,
        LogmanListComponent,
        LogmanYieldMaxListComponent,
        LogmanComponent,
        LogmanYieldMaxComponent,
        SpinnerComponent,
        AppComponent,
        AlertComponent,
        ErrorDialogComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        UserComponent,
        UserListComponent,
        PasswordResetComponent,
        PasswordResetRequestComponent,
        UserRoleComponent,
        UserRoleListComponent,
        UserContactComponent,
        RateProfileComponent,
        RateProfileListComponent,
        RateManagerComponent,
        RateManagerListComponent,
        RateBucketCopyFormComponent,
        // reports
        VacancyReportComponent,
        CheckInOutReportComponent,
        ResRevReportComponent,
        OccupancySummaryReportComponent,
        FutureOccupancyReportComponent,
        AnalyticsDashboardComponent,
        QuoteAnalyticsComponent,
        DailySummaryReportComponent,
        ResSalesReportComponent,
        EscrowsReportComponent,
        EscrowReportComponent,
        EscrowReportAuditComponent,
        EscrowPaymentMappingComponent,
        TravelInsuranceReportComponent,
        ReservationSummaryReportComponent,
        PaymentSummaryReportComponent,
        TaskComponent,
        TaskReservationSelectComponent,
        TaskListComponent,
        QuickTaskComponent,
        PublicTaskListComponent,
        TemplateListComponent,
        TemplateComponent,
        ProjectComponent,
        MaintenanceComponent,
        MaintenanceListComponent,
        PhoneComponent,
        NoteComponent,
        IntervalComponent,
        MessageComponent,
        MessageListComponent,
        MessageTemplateComponent,
        MessageTemplateListComponent,
        GuestMasterProfileComponent,
        GuestMasterProfileListComponent,
        PropertyComponent,
        PropertyListComponent,
        PropertyDeleteComponent,
        DevelopmentComponent,
        DevelopmentListComponent,
        FeatureComponent,
        FeatureListComponent,
        FeatureListAllComponent,
        AuditListComponent,
        AuditEnrichedListComponent,
        PropertySelectComponent,
        ShortTermRentalSelectComponent,
        TopicMessagesViewComponent,
        TeamSelectComponent,
        UserSelectComponent,
        TagSelectComponent,
        TagJoinComponent,
        TagJoinListComponent,
        TagJoinFilterComponent,
        TagAddModalComponent,
        TagSelectModalComponent,
        PropertyMlsComponent,
        TagSelectDdComponent,
        ExtraInfoSelectComponent,
        TeamComponent,
        TaskSummaryComponent,
        TaskEventComponent,
        AccountingRefundComponent,
        BedroomComponent,
        BedroomFormComponent,
        BedComponent,
        BedFormComponent,
        BathroomComponent,
        BathroomFormComponent,
        RateBucketComponent,
        RateBucketFormComponent,
        RateBucketDetailComponent,
        RateBucketDetailFormComponent,
        RateBulkEditComponent,
        RateDetailBulkEditComponent,
        OccupancySummaryComponent,
        SearchTemplateComponent,
        RateLosComponent,
        ReservationInvoiceComponent,
        GuestProfileComponent,
        GuestProfileListComponent,
        ReservationComponent,
        ReservationListComponent,
        RateSummaryComponent,
        RateSeasonSummaryComponent,
        RateSeasonMonthlySummaryComponent,
        RentalsUnitedComponent,
        VRBOLogmanComponent,
        GoogleLogmanComponent,
        VRBOComponent,
        VRBOPropertyComponent,
        VRBOReservationComponent,
        VRBOAvailabilityComponent,
        VRBOReservationsComponent,
        VRBOLodgingRateComponent,
        VRBOUnitAvailabilityComponent,
        VRBOPromotionsComponent,
        VRBOPromotionsDashboardComponent,
        VRBOReviewsComponent,
        VRBOReviewDetailComponent,
        VRBOReviewRespondComponent,
        VRBORateGuestComponent,
        GoogleComponent,
        GoogleDataTableComponent,
        RuBuildingComponent,
        RuPropertyComponent,
        RuAvailabilityComponent,
        RuPricesComponent,
        RuReservationComponent,
        RuQualityCheckComponent,
        ReviewComponent,
        ReviewListComponent,
        ReservationSearchComponent,
        ReservationSearchFormComponent,
        FeatureDisplayComponent,
        PropertyAdminComponent,
        RuReservationDetailComponent,
        RateOverrideComponent,
        RateOverrideFormComponent,
        ResRevComponent,
        ResRevDetailComponent,
        ResRevTotalComponent,
        ResRevTotalDetailComponent,
        HousekeepingOrderComponent,
        ChannelComponent,
        ChannelListComponent,
        GuestRefundListComponent,
        GuestRefundComponent,
        GuestRefundReasonComponent,
        GuestRefundReasonListComponent,
        OwnerProfileComponent,
        OwnerProfileListComponent,
        PropertyProfileListComponent,
        PropertyProfileComponent,
        CancellationPolicyViewComponent,
        FileUploadListComponent,
        FileUploadComponent,
        OrderProductListComponent,
        OrderProductComponent,
        FeaturesListComponent,
        FeaturesComponent,
        GuestMoveListComponent,
        GuestMoveComponent,
        ResSelectComponent,
        ActivityComponent,
        ActivityListComponent,
        ActivityWishlistComponent,
        ActivityWishlistListComponent,
        ActivityFeeComponent,
        ActivityFeeListComponent,
        ActivityProviderComponent,
        ActivityProviderListComponent,
        ActivityScheduleComponent,
        ActivityScheduleListComponent,
        ActivitiesManagerComponent,
        ActivityFormComponent,
        ActivityProviderFormComponent,
        ActivityReservationFormComponent,
        ActivityReservationListComponent,
        RoundNumPipe,
        TruncatePipe,
        SumPropPipe,
        MaxValPipe,
        PaidCountPipe,
        ActivityCountByCatPipe,
        PersonListComponent,
        PersonComponent,
        PersonAddressComponent,
        PersonAddressListComponent,
        PersonEmailListComponent,
        PersonEmailComponent,
        PersonPhoneListComponent,
        PersonPhoneComponent,
        PersonSocialListComponent,
        PersonSocialComponent,
        OrderDetailListComponent,
        OrderDetailComponent,
        OrderInvoiceDetailListComponent,
        OrderInvoiceDetailComponent,
        AddStatementDetailComponent,
        WorkOrderComponent,
        PictureListComponent,
        PictureComponent,
        PropertyImageComponent,
        LostFoundListComponent,
        LostFoundComponent,
        RUDetailedLocationListComponent,
        RUDetailedLocationComponent,
        CostProfileListComponent,
        CostProfileComponent,
        ReservationSelectComponent,
        OwnerProfileGuestListComponent,
        OwnerProfileGuestComponent,
        JobListComponent,
        JobComponent,
        ReservationLedgerComponent,
        ReservationLedgerListComponent,
        ReservationLedgerListSummaryComponent,
        ReservationLedgerListSummaryComponentOld,
        ListingQualityStatusListComponent,
        ListingQualityStatusComponent,
        QualityTestDefinitionsListComponent,
        QualityTestDefinitionFormComponent,
        QualityTestFieldRegistryListComponent,
        QualityTestDashboardComponent,
        MsgCampaignListComponent,
        MsgCampaignComponent,
        MsgListComponent,
        MsgComponent,
        MsgRecipientListComponent,
        MsgRecipientComponent,
        MsgTemplateListComponent,
        MsgTemplateComponent,
        MktgLetterComponent,
        MktgLetterListComponent,
        QuestionAnswerListComponent,
        QuestionAnswerComponent,
        ReservationContainerComponent,
        PropertyFeatureListComponent,
        PropertyFeatureComponent,
        FeatureAdminContainerComponent,
        CodeProjectComponent,
        CodeProjectListComponent,
        CodeTaskListComponent,
        CodeTaskComponent,
        PropertyFeatureTemplateListComponent,
        PropertyFeatureTemplateComponent,
        GuestCampaignComponent,
        GuestSearchTemplateComponent,
        PropertyFeatureTemplateDetailComponent,
        PropertySummaryListComponent,
        // Owners-Others Component
        OwnerStmtComponent,
        OwnerStmtListComponent,
        OwnerStmtRezComponent,
        OwnerStmtRezListComponent,
        OwnerStmtRezDetailComponent,
        OwnerStmtRezDetailListComponent,
        OwnerStmtExpComponent,
        OwnerStmtExpListComponent,
        OwnerStmtExpDetailComponent,
        OwnerStmtExpDetailListComponent,
        TaxPreviewDialogComponent,
        NachaStepsDialogComponent,
        ServiceProductComponent,
        ServiceProductListComponent,
        StatementsComponent,
        CompleteLetterDialogComponent,
        StatementsTaxBreakdownDialogComponent,
        // ReservationLedgerComponent
        ChartAccountComponent,
        ChartAccountListComponent,
        // Proforma
        ProformaComponent,
        ProformaGeneratesComponent,
        ProformaGeneratedListComponent,
        ProformaListComponent,
        ProformaExpenseComponent,
        ProformaIncomeComponent,
        ProformaExpenseListComponent,
        ProformaIncomeListComponent,
        ProformaTemplateComponent,
        ProformaTemplateListComponent,
        ContentListComponent,
        ContentOpsComponent,
        ContentFormComponent,
        MediaTabComponent,
        ContentGenerateComponent,
        NoteListComponent,
        PropertyLeadProfileComponent,
        PropertyLeadProfileListComponent,
        RealtorProfileComponent,
        RealtorProfileListComponent,
        OwnerLeadProfileComponent,
        OwnerLeadProfileListComponent,
        OwnerPropertyComponent,
        OwnerPropertyListComponent,
        // RentalIncomeViewComponent,
        ProformaViewComponent,
        ProformaCopyToFormComponent,
        ProformaCopyFromFormComponent,
        ProformaTargetComponent,
        PropertyConditionListComponent,
        PropertyConditionComponent,
        RUPropertiesStatusListComponent,
        RUPropertiesStatusComponent,
        ArticleComponent,
        ArticleListComponent,
        RealEstateListComponent,
        RealEstateComponent,
        ResSalesDashboardComponent,
        ResMasterComponent,
        ResMasterEscrowComponent,
        DataReportComponent,
        ResSalesSummaryComponent,
        ResSalesOnholdComponent,
        ResSalesAgentComponent,
        ResSalesDevelopmentComponent,
        ResSalesDetailsByYearDashboardComponent,
        SalesByLocationComponent,
        SalesByPropertyComponent,
        CancelsByPropertyComponent,
        HoldsByPropertyComponent,
        HoldsExpireByPropertyComponent,
        UpsellDashboardComponent,
        SalesByChannelComponent,
        SalesReportStatisticsComponent,
        BizDevDashboardComponent,
        DevelopmentDetailsComponent,
        BizDevPropertyDevelopmentComponent,
        BizDevPropertyLocationComponent,
        BizDevPropertyBedroomComponent,
        LocationDetailsComponent,
        ChannelDetailsComponent,
        AgentDetailsComponent,
        AdminDashboardComponent,
        OccupancyDashboardComponent,
        OwnerMgmtCmsListComponent,
        OwnerMgmtCmsComponent,
        MaintenanceEventListComponent,
        MaintenanceEventComponent,
        MaintenanceEventShortTermRentalListComponent,
        MaintenanceEventShortTermRentalComponent,
        FutureOccupancyDashboardComponent,
        OperationsDashboardComponent,
        OperationsDrilldownDialogComponent,
        OperationsDrilldownPageComponent,
        OperationsDashboardShellComponent,
        ReservationsDashboardShellComponent,
        GuestArrivalListComponent,
        SmsComponent,
        ArrivalsBoardComponent,
        ArrivalsSmsDialogComponent,
        ArrivalsAgentBoardComponent,
        EmployeeAcqPaymentListComponent,
        EmployeeAcqPaymentComponent,
        EmployeeProfileListComponent,
        EmployeeProfileComponent,
        QuartzJobListComponent,
        OwnerReviewListComponent,
        OwnerReviewComponent,
        RateReportComponent,
        EmployeePtoListComponent,
        EmployeePtoComponent,
        EmployeePtoRequestComponent,
        WifiQrComponent,
        SendFullMailComponent,
        FeaturePivotSummaryComponent,
        CreateUserComponent,
        BizdevDashboardComponent,
        BizdevHomeComponent,
        BizdevLookupAdminComponent,
        BizdevPipelineComponent,
        BizdevComposeDialogComponent,
        ReservationAdvanceSearchComponent,
        QuoteComponent,
        QuoteListComponent,
        VehicleBookingListComponent,
        VehicleBookingComponent,
        ImapConfigurationListComponent,
        ImapConfigurationComponent,
        ContactListComponent,
        ContactComponent,
        ImportContactComponent,
        MsgHistoryComponent,
        FaqListComponent,
        FaqComponent,
        FaqSectionListComponent,
        FaqSectionComponent,
        FaqCategoryListComponent,
        FaqCategoryComponent,
        InboxComponent,
        InboxListComponent,
        InboxMailSMsComponent,
        InboxListVerticalComponent,
        EmailDirectoryComponent,
        InboxListGuestComponent,
        InboxSmsComponent,
        ConversationComponent,
        BlogListComponent,
        BlogComponent,
        ImapUserMappingComponent,
        ContactSelectComponent,
        UserSearchComponent,
        TeamSearchComponent,
        YieldMaxComponent,
        YieldmaxAdminComponent,
        QualityTestComponent,
        QualityTestListComponent,
        PropertiesListComponent,
        PropertiesComponent,
        OpsDashboardComponent,
        ReservationsComponent,
        ReservationsListComponent,
        RateBucketsListComponent,
        TapeChartListComponent,
        TapeChartWikiListComponent,
        TapeChartComponent,
        TapeChartWikiComponent,
        BestFitListComponent,
        BflHelpDialogComponent,
        TapeChartListCellEditComponent,
        RateBucketsComponent,
        RateSeasonComponent,
        RateSeasonListComponent,
        RateComponent,
        RateListComponent,
        RatesLosComponent,
        RatesLosListComponent,
        OccMapListComponent,
        OccMatrixListComponent,
        AddDayDialogComponent,
        OccProfileListComponent,
        OccDeviationListComponent,
        OccDaysToArrivalListComponent,
        OccDaysMatrixComponent,
        OccDayDetailsDialogComponent,
        OccMapComponent,
        OccMatrixComponent,
        OccProfileComponent,
        OccDeviationComponent,
        OccDaysToArrivalComponent,
        ImportExportComponent,
        ImportDataComponent,
        ArrivalDepartureReportComponent,
        OrderTaxListComponent,
        OrderTaxComponent,
        OrderProductShortTermRentalJoinListComponent,
        OrderProductShortTermRentalJoinComponent,
        OrderProductTaxJoinListComponent,
        OrderProductTaxJoinComponent,
        GuestExitSurveyComponent,
        GuestExitSurveyListComponent,
        GuestRequestListComponent,
        OrderTaxShortTermRentalJoinListComponent,
        OrderTaxShortTermRentalJoinComponent,
        RUReservationsListComponent,
        RUReservationsComponent,
        PropertyConfigComponent,
        TeamListComponent,
        TeamComponent,
        TeamUserSelectComponent,
        PropertyListDetailsComponent,
        OrderDetailTaxListComponent,
        OrderDetailTaxComponent,
        TaskSearchComponent,
        TagListComponent,
        TagComponent,
        TagCategoryManageDialogComponent,
        OpCoverageDialogComponent,
        TrackedLinkListComponent,
        TrackedLinkFormComponent,
        LinkAnalyticsComponent,
        CampaignAnalyticsComponent,
        TemplateAnalyticsComponent,
        AppEventListComponent,
        AppEventDetailComponent,
        MsgUnsubscribeListComponent,
        MsgUnsubscribeComponent,
        OrderListComponent,
        OrderComponent,
        HelpListComponent,
        HelpComponent,
        HelpLinkComponent,
        ReservationCreateComponent,
        CompareWikiReservationListComponent,
        CompareReservationLedgerListComponent,
        RuAvailabilityValidateListComponent,
        CheckDoubleBookingListComponent,
        CompendiumListComponent,
        CompendiumComponent,
        SearchTemplateMsgComponent,
        CompendiumShortTermRentalJoinListComponent,
        CompendiumShortTermRentalJoinComponent,
        PropertyCompendiumComponent,
        AdditionalPaymentComponent,
        ReconcileCapturedPopupComponent,
        ReservationLedgerSummaryComponent,
        OwnerStatementsComponent,
        StatementDashboardComponent,
        NachaToolsDialogComponent,
        StatementProductionGuideComponent,
        StatementComponent,
        StatementAmountPipe,
        StatementDetailComponent,
        StatementDetailListComponent,
        StatementCreateComponent,
        AddStatementDetailComponent,
        EditQuoteComponent,
        ReservationBalanceDueComponent,
        ReservationInOutListComponent,
        WelcomeCardDialogComponent,
        ReservationReportComponent,
        ResADRReportComponent,
        TagRevenueReportComponent,
        ExpenseComponent,
        ExpenseListComponent,
        ExpenseAdvanceSearchComponent,

        ExpenseDetailComponent,
        ExpenseDetailListComponent,
        PropertyProfileOffboardingListComponent,
        PropertyProfileOnboardingListComponent,
        OnboardingTasksDialogComponent,
        CompositeListingListComponent,
        CompositeListingComponent,
        HotelListingListComponent,
        HotelListingComponent,
        ChangeHistoryListComponent,
        HousekeepingReportListComponent,
        ReportReservationComponent,
        RollawayBadComponent,
        FutonBadComponent,
        OpenUnitComponent,
        InterimCleaningComponent,
        LinenServiceComponent,
        TravelAgentProfileComponent,
        TravelAgentProfileListComponent,
        PaymentConfirmComponent,
        PaymentConfirmListComponent,
        AiAgentComponent,
        AiAgentListComponent,
        LandingPageCMSListComponent,
        LandingPageCMSComponent,
        AccessCodeListComponent,
        AccessCodeComponent,
        ViewPropertyCompendiumComponent,
        OwnerStatementsReconsiliationComponent,
        MonthlyStmtExpensesComponent,
        BlogDevelopmentListComponent,
        BlogDevelopmentComponent,
        StyleguideComponent,
        AdminStyleguideComponent,
        UnifiedInboxComponent,
        UnifiedThreadComponent,
        DripCampaignTemplateListComponent,
        DripCampaignTemplateEditComponent,
        DripCampaignInstanceListComponent,
        DripCampaignInstanceDetailComponent,
        UnifiedBubbleComponent,
        GuestHistoryPaneComponent,
        NoteComposerComponent,
        AllMessagesListComponent,
        QbSyncListComponent,
        // Phase 0 — Field Ops Platform
        VendorListComponent,
        VendorEditComponent,
        TaskTemplateListComponent,
        TaskTemplateEditComponent,
        ServiceDetailRollupComponent,
        // Marketing Dashboard
        MarketingDashboardComponent,
        GuestTabComponent,
        KpiSnapshotComponent,
    ], bootstrap: [AppComponent], providers: [
        // fixes a mat bug in v9...may be able to remove in future
        { provide: MatDialogRef, useValue: {} },
        // fixes a mat bug in v9...may be able to remove in future
        { provide: MAT_DIALOG_DATA, useValue: [] },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearance },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: UidInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        // Tinymce
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
        DatePipe,
        MyErrorHandler,
        UserResolver,
        ReservationResolver,
        UserRoleListResolver,
        TaskResolver,
        AvailablePropertyFeaturesResolver,
        AvailableDevelopmentFeaturesResolver,
        PropertyResolver,
        PropertyListResolver,
        DynamicDialogRef,
        // CookieService,
        MessageService,
        ConfirmationService,
        CurrencyPipe,
        ConstantService,
    ] })

export class AppModule { }
